module.exports = __webpack_public_path__ + "static/media/orange.8777ef38.png";